/* eslint-disable import/prefer-default-export */
import * as Sentry from '@sentry/react';
import { GraphQLClient } from 'graphql-request';
import { isEmpty } from 'lodash';

import { getCookie, setCookie } from 'api/utils';
import { configuredStore } from 'store';

const ENV = process.env.NODE_ENV;
const isProd = ENV === 'production';

const fieldsToMask = [
  'firstName',
  'lastName',
  'patientName',
  'patient',
  'email',
  'emailAddress',
  'line1',
  'dob',
  'dateOfBirth',
  'mobilePhoneNumber',
  'homePhoneNumber',
  'phoneNumber',
  'patientEmail',
  'patientPhoneNumber',
];
export const maskPII = (obj) => {
  const maskChar = '*';
  const maskedObj = { ...obj }; // Create a shallow copy to avoid modifying the original object

  // eslint-disable-next-line no-restricted-syntax
  for (const key in maskedObj) {
    if (Object.prototype.hasOwnProperty.call(maskedObj, key)) {
      const value = maskedObj[key];

      if (typeof value === 'object' && value !== null) {
        // Recursively mask nested objects
        maskedObj[key] = maskPII(value);
      } else if (fieldsToMask.includes(key) && typeof value === 'string') {
        // Mask the string value if it's a PII field
        maskedObj[key] = maskChar.repeat(value.length);
      }
    }
  }

  return maskedObj;
};

/* istanbul ignore next */
const endpoint = isProd
  ? `${process.env.REACT_APP_GRAPHQL_ENDPOINT}/graphql`
  : `${window.location.origin}/graphql`;

const requestMiddleware = (request) => {
  const jwt = getCookie('pomAccessToken');
  const sfgp = getCookie('tokenSfgp');

  const { currentTenantId, fulfillingPharmacyIds } = configuredStore.store.getState().auth;

  Sentry.addBreadcrumb({
    category: request.operationName,
    level: 'info',
    data: maskPII({ variables: request.variables }),
  });

  return {
    ...request,
    headers: {
      ...request.headers,
      'x-token-sfgp': sfgp,
      Authorization: jwt,
      ...(currentTenantId && { 'x-pharmacy-id': currentTenantId }),
      ...(!isEmpty(fulfillingPharmacyIds) && {
        'x-fulfilling-pharmacy-ids': fulfillingPharmacyIds.toString(),
      }),
    },
  };
};

const responseMiddleware = (response) => {
  const { headers } = response;

  const newToken = headers?.get('x-new-token');
  /* istanbul ignore if */
  if (newToken) {
    setCookie({ name: 'pomAccessToken', value: newToken });
  }

  const sfgp = headers?.get('x-token-sfgp');
  /* istanbul ignore if */
  if (sfgp) {
    setCookie({ name: 'tokenSfgp', value: sfgp });
  }
};

export default new GraphQLClient(endpoint, { requestMiddleware, responseMiddleware });
